if (!customElements.get('custom-banner-slider')) {
  class CustomBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onDotClick = this.onDotClick.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.custom-banner-carousel__track');

      this.section = this.closest('.shopify-section') || this.closest('section') || this.parentElement;
      this.prevButtons = [...(this.section?.querySelectorAll('button[name="previous"]') || [])];
      this.nextButtons = [...(this.section?.querySelectorAll('button[name="next"]') || [])];
      this.dots = [...this.querySelectorAll('.custom-banner-carousel__dot')];

      if (!this.track) return;

      this.setColumns();
      this.update();

      this.prevButtons.forEach((button) => button.addEventListener('click', this.onClick));
      this.nextButtons.forEach((button) => button.addEventListener('click', this.onClick));
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      this.prevButtons.forEach((button) => button.removeEventListener('click', this.onClick));
      this.nextButtons.forEach((button) => button.removeEventListener('click', this.onClick));
      this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));

      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    setColumns() {
      const desktopCols = this.dataset.desktopCols || '5';
      const mobileCols = this.dataset.mobileCols || '2';

      this.track.style.setProperty('--desktop-cols', desktopCols);
      this.track.style.setProperty('--mobile-cols', mobileCols);
    }

    getSlideStep() {
      const firstSlide = this.track.querySelector('.custom-banner-carousel__slide');
      if (!firstSlide) return 0;

      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
      return firstSlide.getBoundingClientRect().width + gap;
    }

    getCurrentIndex() {
      const step = this.getSlideStep();
      if (!step) return 0;
      return Math.round(this.track.scrollLeft / step);
    }

    onClick(event) {
      const step = this.getSlideStep();
      if (!step) return;

      const isNext = event.currentTarget.name === 'next';
      const amount = isNext ? step : -step;

      this.track.scrollBy({
        left: amount,
        behavior: 'smooth'
      });
    }

    onDotClick(event) {
      const index = Number(event.currentTarget.dataset.slideIndex || 0);
      const step = this.getSlideStep();
      if (!step) return;

      this.track.scrollTo({
        left: step * index,
        behavior: 'smooth'
      });
    }

    onScroll() {
      this.update();
    }

    onResize() {
      this.setColumns();
      this.update();
    }

    update() {
      if (!this.track) return;

      const tolerance = 4;
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
      const isStart = this.track.scrollLeft <= tolerance;
      const isEnd = this.track.scrollLeft >= maxScrollLeft - tolerance;
      const currentIndex = this.getCurrentIndex();

      this.classList.toggle('is-start', isStart);
      this.classList.toggle('is-end', isEnd);

      this.prevButtons.forEach((button) => {
        button.disabled = isStart;
        button.style.opacity = isStart ? '0.4' : '1';
        button.style.pointerEvents = isStart ? 'none' : 'auto';
      });

      this.nextButtons.forEach((button) => {
        button.disabled = isEnd;
        button.style.opacity = isEnd ? '0.4' : '1';
        button.style.pointerEvents = isEnd ? 'none' : 'auto';
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('custom-banner-slider', CustomBannerSlider);
}

document.addEventListener('shopify:section:load', (event) => {
  const sliders = event.target.querySelectorAll('custom-banner-slider');
  sliders.forEach((slider) => {
    if (typeof slider.update === 'function') {
      slider.setColumns();
      slider.update();
    }
  });
});